import {useEffect, useState, useRef} from "react";
import Menu from "../menu";
import Avatar from "../avatar";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useMediaQuery } from "react-responsive";

function Sider({ expand, setSede, setEmpresa }) {
    const [collapsed, setCollapsed] = useState(expand);
    let closeTimeout = useRef(null);
    let isTabletMid = useMediaQuery({ query: "(min-width: 768px)" });

const startAutoClose = () => {
  closeTimeout.current = setTimeout(() => setCollapsed(false), 300);
};

const cancelAutoClose = () => {
  if (closeTimeout.current) {
    clearTimeout(closeTimeout.current); // .current
    closeTimeout.current = null;
  }
};

const sidebarEvents = !isTabletMid
  ? {
      onMouseEnter: cancelAutoClose,
      onMouseLeave: startAutoClose,
    }
  : {};


useEffect(() => {
      if (expand) {
        cancelAutoClose();
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    }, [expand]);

  return (<div id="sidebar" className={clsx('h-[calc(100vh-3rem)] min-h-full md:min-w-[4rem] bg-sidebar overflow-hidden transition-all duration-300 ease-in-out md:relative fixed md:translate-x-0',
                                      collapsed ? 'z-10 w-[12rem] md:w-[15rem] 2xl:w-[15rem] translate-x-0':'w-0 md:w-[4rem] -translate-x-full')}
                                      {...sidebarEvents}>
      <div className="max-h-[78vh] md:max-h-[81vh] overflow-y-auto overflow-x-hidden">   
        <Menu expand={collapsed} setSede={setSede} setEmpresa={setEmpresa}></Menu>
      </div>
      <Avatar expand={collapsed}></Avatar>
    </div>
  );
}
Sider.propTypes = {
  expand: PropTypes.bool.isRequired,
  setSede: PropTypes.func.isRequired,
  setEmpresa: PropTypes.func.isRequired,
};
export default Sider;
